/* The Snout - touch swipe for the review sliders (Home page and Doberman landing page).
   1. A card losing its touch capture must not end a swipe on the Home slider.
   2. The landing page slider gets swipe: left = next review, right = previous.
   3. The landing page buy-box photo gets arrows and swipe; more than 5 thumbnails scroll in one row.
   4. The Doberman Collection cards show every photo, with arrows and swipe. */
(function () {
  'use strict';
  if (window.SnoutTouch) return;
  window.SnoutTouch = true;
  var d = document;

  d.addEventListener('lostpointercapture', function (e) {
    var t = e.target;
    var vp = t && t.closest ? t.closest('[data-sn-reviews-viewport]') : null;
    if (vp && t !== vp) e.stopPropagation();
  }, true);

  function bind(root) {
    if (root.getAttribute('data-rv-touch')) return;
    var vp = root.querySelector('.rv-viewport');
    var next = root.querySelector('[data-rv-next]');
    var prev = root.querySelector('[data-rv-prev]');
    if (!vp || !next || !prev) return;
    root.setAttribute('data-rv-touch', '1');
    vp.style.touchAction = 'pan-y';
    var s = null;
    vp.addEventListener('pointerdown', function (e) {
      if (e.pointerType === 'mouse') return;
      s = { id: e.pointerId, x: e.clientX, y: e.clientY };
    });
    function end(e) {
      if (!s || e.pointerId !== s.id) return;
      var dx = e.clientX - s.x, dy = e.clientY - s.y;
      s = null;
      if (e.type === 'pointercancel') return;
      if (Math.abs(dx) > 40 && Math.abs(dx) > Math.abs(dy)) (dx < 0 ? next : prev).click();
    }
    vp.addEventListener('pointerup', end);
    vp.addEventListener('pointercancel', end);
  }


  /* 3. Landing page buy box: arrows on the big photo, plus swipe, to move through the photos */
  var GAL_CSS = '.snl .gal-main .gal-arrow{position:absolute;top:50%;z-index:2;width:44px;height:44px;margin-top:-22px;padding:0;border:0;border-radius:999px;' +
    'display:inline-flex;align-items:center;justify-content:center;background:rgba(255,255,255,.95);color:#0a0a0a;' +
    'box-shadow:0 4px 16px rgba(0,0,0,.14);cursor:pointer;-webkit-tap-highlight-color:transparent;transition:background-color .3s,color .3s,transform .3s}' +
    '.snl .gal-main .gal-arrow svg{width:18px;height:18px}' +
    '.snl .gal-main .gal-arrow--prev{left:14px}.snl .gal-main .gal-arrow--next{right:14px}' +
    '@media (hover:hover){.snl .gal-main .gal-arrow:hover{background:#0a0a0a;color:#fff}}' +
    '.snl .gal-main .gal-arrow:focus-visible{outline:2px solid #c49a6c;outline-offset:2px}' +
    '@media (max-width:767px){.snl .gal-main .gal-arrow{width:40px;height:40px;margin-top:-20px}.snl .gal-main .gal-arrow--prev{left:10px}.snl .gal-main .gal-arrow--next{right:10px}}' +
    /* More than 5 photos: the thumbnails become one row that scrolls sideways, with part of the next one showing */
    '.snl .gal-thumbs.gal-thumbs--strip{position:relative;grid-template-columns:none;grid-auto-flow:column;grid-auto-columns:calc((100% - 48px) / 5.4);' +
    'overflow-x:auto;overscroll-behavior-x:contain;scroll-snap-type:x proximity;scrollbar-width:none;padding:1px}' +
    '.snl .gal-thumbs.gal-thumbs--strip::-webkit-scrollbar{display:none}' +
    '.snl .gal-thumbs.gal-thumbs--strip>div{scroll-snap-align:start}' +
    '@media (max-width:767px){.snl .gal-thumbs.gal-thumbs--strip{grid-auto-columns:calc((100% - 32px) / 5.4)}}';
  var ARROW = {
    prev: '<svg aria-hidden="true" focusable="false" fill="none" stroke="currentColor" stroke-width="1.8" viewBox="0 0 24 24"><path stroke-linecap="round" stroke-linejoin="round" d="M10.5 19.5L3 12m0 0l7.5-7.5M3 12h18"/></svg>',
    next: '<svg aria-hidden="true" focusable="false" fill="none" stroke="currentColor" stroke-width="1.8" viewBox="0 0 24 24"><path stroke-linecap="round" stroke-linejoin="round" d="M13.5 4.5L21 12m0 0l-7.5 7.5M21 12H3"/></svg>'
  };

  function bindGallery(main) {
    if (main.getAttribute('data-gal-arrows')) return;
    var gallery = main.parentElement;
    var thumbs = gallery ? gallery.querySelectorAll('.gal-thumbs > div') : [];
    if (thumbs.length < 2) return;
    main.setAttribute('data-gal-arrows', '1');
    if (thumbs.length > 5) thumbs[0].parentElement.classList.add('gal-thumbs--strip');
    if (!d.getElementById('sn-gal-arrows-css')) {
      var st = d.createElement('style');
      st.id = 'sn-gal-arrows-css';
      st.textContent = GAL_CSS;
      d.head.appendChild(st);
    }
    function step(dir) {
      var list = gallery.querySelectorAll('.gal-thumbs > div');
      var cur = 0;
      for (var i = 0; i < list.length; i++) { if (list[i].classList.contains('on')) { cur = i; break; } }
      var nx = list[(cur + dir + list.length) % list.length];
      nx.click();
      showThumb(nx);
    }
    function showThumb(el) {
      var strip = el.parentElement;
      if (!strip.classList.contains('gal-thumbs--strip')) return;
      var left = el.offsetLeft - (strip.clientWidth - el.offsetWidth) / 2;
      strip.scrollTo({ left: Math.max(0, left), behavior: 'smooth' });
    }
    ['prev', 'next'].forEach(function (k) {
      var b = d.createElement('button');
      b.type = 'button';
      b.className = 'gal-arrow gal-arrow--' + k;
      b.setAttribute('aria-label', k === 'prev' ? 'Previous photo' : 'Next photo');
      b.innerHTML = ARROW[k];
      b.addEventListener('click', function (e) { e.preventDefault(); e.stopPropagation(); step(k === 'prev' ? -1 : 1); });
      main.appendChild(b);
    });
    main.style.touchAction = 'pan-y';
    var s = null;
    main.addEventListener('pointerdown', function (e) {
      if (e.pointerType === 'mouse' || (e.target.closest && e.target.closest('.gal-arrow'))) return;
      s = { id: e.pointerId, x: e.clientX, y: e.clientY };
    });
    function end(e) {
      if (!s || e.pointerId !== s.id) return;
      var dx = e.clientX - s.x, dy = e.clientY - s.y;
      s = null;
      if (e.type === 'pointercancel') return;
      if (Math.abs(dx) > 40 && Math.abs(dx) > Math.abs(dy)) step(dx < 0 ? 1 : -1);
    }
    main.addEventListener('pointerup', end);
    main.addEventListener('pointercancel', end);
  }

  /* 4. Doberman Collection cards: every photo of the design in the card, with arrows and swipe */
  function bindCard(track) {
    if (track.getAttribute('data-dc-ready')) return;
    track.setAttribute('data-dc-ready', '1');
    var media = track.parentElement;
    var card = track.closest('.dc');
    var open = card ? card.querySelector('.dc-open') : null;
    var cur = 0, swipedAt = 0, s = null;
    function go(i) {
      var n = track.children.length;
      if (n < 2) return;
      cur = (i + n) % n;
      track.scrollTo({ left: cur * track.clientWidth, behavior: 'smooth' });
    }
    media.querySelectorAll('[data-dc-step]').forEach(function (b) {
      b.addEventListener('click', function (e) {
        e.preventDefault();
        e.stopPropagation();
        if (Date.now() - swipedAt < 500) return;
        go(cur + parseInt(b.getAttribute('data-dc-step'), 10));
      });
    });
    /* Swipe anywhere on the photo, arrows included (the cards are small on phones) */
    media.style.touchAction = 'pan-y';
    media.querySelectorAll('[data-dc-step]').forEach(function (b) { b.style.touchAction = 'pan-y'; });
    media.addEventListener('pointerdown', function (e) {
      if (e.pointerType === 'mouse') return;
      s = { id: e.pointerId, x: e.clientX, y: e.clientY };
    });
    function end(e) {
      if (!s || e.pointerId !== s.id) return;
      var dx = e.clientX - s.x, dy = e.clientY - s.y;
      s = null;
      if (e.type === 'pointercancel') return;
      if (Math.abs(dx) > 20 && Math.abs(dx) > Math.abs(dy)) { swipedAt = Date.now(); go(cur + (dx < 0 ? 1 : -1)); }
    }
    media.addEventListener('pointerup', end);
    media.addEventListener('pointercancel', end);
    /* A tap on the photo (not a swipe) still opens the design's details, as before */
    track.addEventListener('click', function () {
      if (Date.now() - swipedAt < 500) return;
      if (open) open.click();
    });
    window.addEventListener('resize', function () { track.scrollTo({ left: cur * track.clientWidth }); });
  }

  function init(scope) {
    var list = (scope || d).querySelectorAll ? (scope || d).querySelectorAll('[data-rv]') : [];
    Array.prototype.forEach.call(list, bind);
    var gals = (scope || d).querySelectorAll ? (scope || d).querySelectorAll('.snl .gal-main') : [];
    Array.prototype.forEach.call(gals, bindGallery);
    var cards = (scope || d).querySelectorAll ? (scope || d).querySelectorAll('.snl [data-dc-track]') : [];
    Array.prototype.forEach.call(cards, bindCard);
  }
  if (d.readyState === 'loading') d.addEventListener('DOMContentLoaded', function () { init(d); });
  else init(d);
  d.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();
